import styled, { DefaultTheme, ThemedStyledProps } from 'styled-components';
import { getSpacing } from 'utils/spacing';
import { StyledProps } from './types';

function flexDirection(
  props: ThemedStyledProps<StyledProps, DefaultTheme>,
): string {
  const { $orientation } = props;
  return $orientation === 'horizontal' ? 'row' : 'column';
}

function getSpaceStyle(props: ThemedStyledProps<StyledProps, DefaultTheme>) {
  const { $orientation } = props;
  const property = $orientation === 'horizontal' ? 'margin-left' : 'margin-top';
  return `${property}: ${getSpacing(props)}`;
}

export const Root = styled.div<StyledProps>`
  align-items: ${({ $align }) => $align};
  display: flex;
  flex-direction: ${flexDirection};
  justify-content: ${({ $justify }) => $justify};

  & > *:not(:first-child) {
    ${getSpaceStyle};
  }
`;
